import { configureStore } from '@reduxjs/toolkit'
import { storyPaths } from '../features/storyPaths.js'
import globalCooldownSlice, { timerTick as globalCooldownTimerTick } from '../features/global_cooldown/globalCooldownSlice.js'
import settingsReducer from '../features/settings/settingsSlice.js'
import openingSceneSlice from '../features/opening_scene/openingSceneSlice.js'
import { saveState, loadState } from '../local_storage/index.js'

import pull from 'pull-stream'
import Pushable from 'pull-pushable'
import Throttle from 'pull-throttle'

const storyPathReducers = Object.fromEntries(
  storyPaths.map(({ key, slice }) => [key, slice.reducer])
)

export const store = configureStore({
  reducer: {
    ...storyPathReducers,
    globalCooldown: globalCooldownSlice,
    openingScene: openingSceneSlice,
    settings: settingsReducer
  },
  // Disable this for debugging
   preloadedState: loadState()
})

const pusher = Pushable();

pull(pusher, Throttle(2000), pull.drain(saveState))

store.subscribe(() => {
  pusher.push(store.getState())
})

setInterval(() => {
  storyPaths.forEach(({ slice }) => store.dispatch(slice.actions.timerTick()))
  store.dispatch(globalCooldownTimerTick())
}, 1000)
